import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "wrapper-inbound-tabs status-tabs mb-5"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "animated": false,
      "size": "small",
      "data-permission": "wrapper_inbound_status",
      "id": "wrapper_inbound_status"
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.searchData.status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "status", $$v);
      },
      expression: "searchData.status"
    }
  }, [_c('a-tab-pane', {
    key: undefined,
    attrs: {
      "tab": _vm.t('全部 {0}', [_vm.searchData.status === undefined ? _vm.total !== null ? "(" + _vm.total + ")" : '' : ''])
    }
  }), _vm._l(_vm.inOrderStatusEnum, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": _vm.searchData.status === item.value ? item.text + (_vm.total !== null ? "(" + _vm.total + ")" : '') : item.text
      }
    });
  })], 2)], 1), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "value": "order_code",
      "data-permission": "wrapper_inbound_code_type",
      "id": "wrapper_inbound_code_type",
      "allow-clear": false
    }
  }, _vm._l(_vm.packageOrderCodeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "allowClear": "",
      "maxLength": 100,
      "data-permission": "wrapper_inbound_code_value",
      "id": "wrapper_inbound_code_value"
    },
    model: {
      value: _vm.searchData.order_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "order_code", $$v);
      },
      expression: "searchData.order_code"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5165\u5E93\u4ED3\u5E93\uFF08\u533A\u57DF\uFF09"),
      "data-permission": "wrapper_inbound_warehouse_code",
      "id": "wrapper_inbound_warehouse_code",
      "show-tip": "",
      "placeholder": _vm.t('入库仓库（区域）'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code
    }, [_vm._v(_vm._s(item.warehouse_name_text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "allow-clear": false,
      "data-permission": "wrapper_inbound_package_option",
      "id": "wrapper_inbound_package_option"
    },
    model: {
      value: _vm.searchData.package_option,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_option", $$v);
      },
      expression: "searchData.package_option"
    }
  }, _vm._l(_vm.packageOptionEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "allowClear": "",
      "maxLength": 50,
      "data-permission": "wrapper_inbound_package_option_value",
      "id": "wrapper_inbound_package_option_value"
    },
    model: {
      value: _vm.searchData.package_option_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_option_value", $$v);
      },
      expression: "searchData.package_option_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5305\u6750\u7C7B\u578B"),
      "data-permission": "wrapper_inbound_package_category",
      "id": "wrapper_inbound_package_category",
      "show-tip": "",
      "placeholder": _vm.t('包材类型'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.package_category,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "package_category", $$v);
      },
      expression: "searchData.package_category"
    }
  }, _vm._l(_vm.packageCategoryEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u66F4\u65B0\u65F6\u95F4"),
      "allow-clear": false,
      "data-permission": "wrapper_inbound_time_type",
      "id": "wrapper_inbound_time_type",
      "placeholder": _vm.t('更新时间')
    },
    model: {
      value: _vm.searchData.time_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "time_type", $$v);
      },
      expression: "searchData.time_type"
    }
  }, _vm._l(_vm.wrapperTimeEnum, function (item) {
    return _c('a-select-option', {
      key: item.value
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD",
      "data-permission": "wrapper_inbound_time_value",
      "id": "wrapper_inbound_time_value"
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "wrapper_inbound_search",
      "data-permission": "wrapper_inbound_search",
      "id": "wrapper_inbound_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "wrapper_inbound_reset",
      "data-permission": "wrapper_inbound_reset",
      "id": "wrapper_inbound_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "ovh mb-15"
  }, [_c('span', {
    staticClass: "fl",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('div', {
    staticClass: "ml-20 fl"
  }, [_c('a-dropdown', [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "wrapper_inbound_export_all",
      "id": "wrapper_inbound_export_all",
      "data-sign": "wrapper_inbound_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "wrapper_inbound_export_select",
      "id": "wrapper_inbound_export_select",
      "data-sign": "wrapper_inbound_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _vm.searchData.status === _vm.$enum.warehouse.WrapperInnboundStatus.DRAFT ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'wrapper_inbound_submit',
      expression: "'wrapper_inbound_submit'"
    }],
    staticClass: "ml-10",
    attrs: {
      "data-permission": "wrapper_inbound_batch_submit",
      "id": "wrapper_inbound_batch_submit",
      "data-sign": "wrapper_inbound_submit",
      "fbu-analyse-name": $t("\u63D0\u4EA4")
    },
    on: {
      "click": _vm.handleSubmitBulk
    }
  }, [_vm._v(_vm._s(_vm.t('提交')))]) : _vm._e()], 1), _vm.isProductPrivateWrapper ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'wrapper_inbound_add',
      expression: "'wrapper_inbound_add'"
    }],
    staticClass: "fr",
    attrs: {
      "data-permission": "wrapper_inbound_add",
      "id": "wrapper_inbound_add",
      "data-sign": "wrapper_inbound_add",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E\u5305\u6750\u5165\u5E93")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.t('新增包材入库')))]) : _vm._e()], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "name": "wrapperInboundList",
      "columns": _vm.columns,
      "useMouseTool": "",
      "data-sign": "wrapper_inbound_list",
      "data-source": _vm.dataList,
      "fixed-header": "",
      "is-filter-box": "",
      "row-selection": _vm.rowSelection,
      "row-key": "order_code",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "status_text",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "160px"
          }
        }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(record.status_text)) + " ")]);
      }
    }, {
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.$util.getWarehouseCodeWithName(record.warehouse_code, record.warehouse_name_cn))) + " ")]);
      }
    }, {
      key: "details",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "160px"
          }
        }, [record.pack_num_list && record.pack_num_list.length ? _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.pack_num_list[0].package_code)) + "*" + _vm._s(_vm._f("filterEmpty")(record.pack_num_list[0].package_num)))]) : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]), record.pack_num_list && record.pack_num_list.length > 1 ? _c('a', {
          attrs: {
            "data-sign": "wrapper_inbound_details_view",
            "href": "javascript:;",
            "fbu-analyse-name": $t("\u67E5\u770B\u66F4\u591A")
          },
          on: {
            "click": function ($event) {
              _vm.handleMore(record.pack_num_list, _vm.t('预报包材信息'));
            }
          }
        }, [_vm._v(_vm._s(_vm.t('查看更多')))]) : _vm._e()]);
      }
    }, {
      key: "receive_details",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticStyle: {
            "width": "160px"
          }
        }, [record.receive_details && record.receive_details.length ? _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.receive_details[0].package_code)) + "*" + _vm._s(_vm._f("filterEmpty")(record.receive_details[0].package_num)))]) : _c('div', [_vm._v(_vm._s(_vm._f("filterEmpty")('')))]), record.receive_details && record.receive_details.length > 1 ? _c('a', {
          attrs: {
            "data-sign": "wrapper_inbound_receive_detail_view",
            "href": "javascript:;",
            "fbu-analyse-name": $t("\u67E5\u770B\u66F4\u591A")
          },
          on: {
            "click": function ($event) {
              _vm.handleMore(record.receive_details, _vm.t('收货包材信息'));
            }
          }
        }, [_vm._v(_vm._s(_vm.t('查看更多')))]) : _vm._e()]);
      }
    }, {
      key: "remark",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('text-ellipses', {
          attrs: {
            "data": record.remark
          }
        })], 1);
      }
    }, {
      key: "time",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('div', {
          staticClass: "colon-align"
        }, [_c('span', {
          staticClass: "colon-align-label"
        }, [_vm._v(_vm._s(_vm.t('创建')) + _vm._s(_vm.tc('：')))]), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.create_time)))])]), _c('div', {
          staticClass: "colon-align"
        }, [_c('span', {
          staticClass: "colon-align-label"
        }, [_vm._v(_vm._s(_vm.t('提交')) + _vm._s(_vm.tc('：')))]), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.submit_time)))])]), _c('div', {
          staticClass: "colon-align"
        }, [_c('span', {
          staticClass: "colon-align-label"
        }, [_vm._v(_vm._s(_vm.t('收货')) + _vm._s(_vm.tc('：')))]), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.receive_time)))])]), _c('div', {
          staticClass: "colon-align"
        }, [_c('span', {
          staticClass: "colon-align-label"
        }, [_vm._v(_vm._s(_vm.t('废弃')) + _vm._s(_vm.tc('：')))]), _c('span', [_vm._v(_vm._s(_vm._f("filterEmpty")(record.discard_time)))])])]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record.status === _vm.$enum.warehouse.WrapperInnboundStatus.DRAFT ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'wrapper_inbound_edit',
            expression: "'wrapper_inbound_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_inbound_edit",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]) : _vm._e(), record.status === _vm.$enum.warehouse.WrapperInnboundStatus.DRAFT ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'wrapper_inbound_submit',
            expression: "'wrapper_inbound_submit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_inbound_submit",
            "fbu-analyse-name": $t("\u63D0\u4EA4")
          },
          on: {
            "click": function ($event) {
              return _vm.submitOrderAudit([record.order_code]);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('提交')))]) : _vm._e(), record.status === _vm.$enum.warehouse.WrapperInnboundStatus.DRAFT ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'wrapper_inbound_delete',
            expression: "'wrapper_inbound_delete'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_inbound_delete",
            "fbu-analyse-name": $t("\u5220\u9664")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDelete(record.order_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('删除')))]) : _vm._e(), record.status === _vm.$enum.warehouse.WrapperInnboundStatus.WAIT_RECEIVING ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'wrapper_inbound_discard',
            expression: "'wrapper_inbound_discard'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_inbound_discard",
            "fbu-analyse-name": $t("\u5E9F\u5F03")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDiscard(record.order_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('废弃')))]) : _vm._e(), record.details && record.details.length && record.details[0].board_no ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'wrapper_inbound_print',
            expression: "'wrapper_inbound_print'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-sign": "wrapper_inbound_print",
            "fbu-analyse-name": $t("\u6253\u5370")
          },
          on: {
            "click": function ($event) {
              return _vm.handlePrint(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('打印')))]) : _vm._e()]);
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "consumable_type_text"
    },
    slot: "consumable_type_text"
  }, [_vm._v(" " + _vm._s(_vm.t('包材')) + " ")])])], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "isFixed": "",
      "name": "wrapperInboundList",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('edit-modal', {
    attrs: {
      "visible": _vm.addEditVisible,
      "rowData": _vm.rowData
    },
    on: {
      "update:visible": function ($event) {
        _vm.addEditVisible = $event;
      },
      "success": _vm.queryList
    }
  }), _c('more-wrapper-modal', {
    attrs: {
      "visible": _vm.moreWrapperVisible,
      "rowData": _vm.rowData
    },
    on: {
      "update:visible": function ($event) {
        _vm.moreWrapperVisible = $event;
      }
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };